import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { H4 } from 'components/Typography';

const PopUpConfirmation = ({
    handleCancel,
    handleAction,
    data,
    status,
    disableButton,
}) => {
    return (
        <Box>
            <H4 align={'center'}>
                Are you sure to set status abstract from {data.user.fullName} to
                <span style={{ color: status === 'Reject' ? 'red' : 'green' }}>
                    &nbsp;{status}
                </span>?
            </H4>
            <Typography align={'center'}>
                Abstract Title
            </Typography>
            <Typography 
                sx={{ fontStyle: 'italic' }}
                fontWeight={100}
                variant="body2"
                align={'center'}
                mt={2}>
                {data.title ? data.title : 'No Title'}
            </Typography>

            <Stack
                direction="row"
                spacing={1}
                mt={2}
                sx={{ justifyContent: 'center' }}
            >
                <Button
                    disabled={disableButton}
                    variant="contained"
                    color={status === 'Approve' ? 'primary' : 'error'}
                    onClick={() => handleAction(status)}
                >
                    {status}
                </Button>
                <Button
                    disabled={disableButton}
                    variant="outlined"
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
            </Stack>
        </Box>
    );
};

export default PopUpConfirmation;
